export { default } from 'Components/Cart/DeliveryDiscount/DeliveryDiscount'
